import { useEffect } from 'react';

import classnames from 'classnames';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
/* Material UI */
import DialogTitle from '@material-ui/core/DialogTitle';

import NibButton from '../NibButton/NibButton';
/* Styles */
import css from './nibDialog.module.sass';

const NibDialog = ({
  children = null,
  onClose = () => {},
  width,
  maxWidth,
  className,
  papperClass,
  title,
  useButtons = false,
  cancelButtonTitle = '',
  confirmButtonTitle = '',
  onlyOk = false,
  subtitle,
  open = false,
  wrapperProps = {},
  paperProps = {},
  contentWrapperProps = {},
  titleChildren = null,
  titleStyle,
  titleClassname,
  subtitleClassname,
  disableBackdropClick = false,
  ...rest
}) => {
  const handleClose = (isAgree) => () => {
    onClose(isAgree);
  };

  useEffect(() => {
    if (open) {
      let main = document.getElementById('root');
      main.classList.add('openDialog');
    } else {
      let main = document.getElementById('root');
      main.classList.remove('openDialog');
    }
  }, [open]);

  return (
    <Dialog
      id="app-modal"
      scroll="body"
      className={css.wrap}
      PaperProps={{
        className: classnames(css.papper, papperClass && papperClass),
        style: { ...(width && { width }), ...(maxWidth && { maxWidth }) },
        ...paperProps,
      }}
      BackdropProps={{ className: css.backDrop }}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' && disableBackdropClick) return;
        handleClose(false)();
      }}
      open={open}
      {...wrapperProps}
    >
      {title && (
        <DialogTitle className={css.title}>
          <div className={css.header}>
            <h3 style={titleStyle} className={titleClassname ? titleClassname : 'text-[24px]'}>
              {title}
            </h3>
            {subtitle && <p className={subtitleClassname}>{subtitle}</p>}
            {titleChildren && titleChildren}
          </div>
        </DialogTitle>
      )}
      <DialogContent className={className && className} {...contentWrapperProps}>
        {children}
      </DialogContent>
      {useButtons && (
        <DialogActions>
          <NibButton label={cancelButtonTitle || 'Cancel'} mui={true} onClick={handleClose(false)} />
          <NibButton label={confirmButtonTitle || 'Ok'} mui={true} onClick={handleClose(true)} />
        </DialogActions>
      )}
      {onlyOk && (
        <DialogActions>
          <NibButton label="Ok" mui={true} onClick={handleClose(true)} />
        </DialogActions>
      )}
    </Dialog>
  );
};

export default NibDialog;
